// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { initializeConnector, Web3ReactHooks } from '@web3-react/core';
import { MetaMask } from '@web3-react/metamask';

// MetaMask connector - with custom provider support
export const [metaMask, metaMaskHooks] = initializeConnector<MetaMask>(
  actions => new MetaMask({ actions, options: { silent: true } })
);

// Export connectors array
export const connectors = [[metaMask, metaMaskHooks]];

// Export hooks
export const hooks = {
  metaMask: metaMaskHooks,
};

// Connector types
export enum ConnectorType {
  METAMASK = 'metamask',
  WALLETCONNECT = 'walletconnect',
}

// Helper functions
export function getConnector(type: ConnectorType) {
  switch (type) {
    case ConnectorType.METAMASK:
      return metaMask;
    case ConnectorType.WALLETCONNECT:
      return null; // Temporarily disabled due to Babel compatibility
    default:
      throw new Error('Unknown connector type: ' + type);
  }
}

export function getHooks(type: ConnectorType) {
  switch (type) {
    case ConnectorType.METAMASK:
      return metaMaskHooks;
    case ConnectorType.WALLETCONNECT:
      return null; // Temporarily disabled due to Babel compatibility
    default:
      throw new Error('Unknown connector type: ' + type);
  }
}

// Backward compatibility
export { metaMask as metamask };
export const portis = null;
export const fortmatic = null;
export const walletConnect = null;
export const walletConnectHooks = null;
